export const EMAIL_CONSTANTS = {
  MAX_LENGTH: 254 // RFC 5321
} as const;

export const EMAIL_MESSAGES = {
  REQUIRED: 'Email is required',
  MAX_LENGTH: `Email must be at most ${EMAIL_CONSTANTS.MAX_LENGTH} characters`,
  INVALID: 'Please enter a valid email address'
} as const;
